import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/api";

const VerifyPage = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(t('public.verify.verifying'));
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await api.publicVerify(token);
        if (r && r.alreadyVerified) {
          if (r.code) {
            navigate(`/claim/${r.code}`);
            return;
          }
          setStatus(r.message || t('public.verify.alreadyVerified'));
          return;
        }
        // direkt zur Claim-Seite weiter
        navigate(`/claim/${r.code}`);
      } catch (e) {
        const msg = e?.message || t('public.verify.error');
        // Freundlicher Hinweis, wenn Token bereits genutzt oder Teilnahme bereits erfolgt
        if (/schon teilgenommen|bereits|token ungültig/i.test(msg)) {
          setError("");
          setStatus(t('public.verify.alreadyVerifiedSent'));
        } else {
          setError(msg);
          setStatus(t('public.verify.error'));
        }
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-4">
      <div className="bg-background p-6 rounded shadow w-full max-w-md text-center space-y-2">
        <h1 className="text-lg font-semibold">{t('public.verify.title')}</h1>
        {error ? (
          <p className="text-sm text-red-600">{error}</p>
        ) : (
          <p className="text-sm">{status}</p>
        )}
      </div>
    </div>
  );
};
export default VerifyPage;
